import { createSelector } from 'reselect'
import { getPermissionScope } from '../../../../lib/permissions'
import { Permissions } from '../../../../constants/permissions'
const selectSession = state => state.session

const selectSessionData = createSelector(
  selectSession,
  ({ sessionData }) => sessionData,
)

export const getRole = createSelector(selectSessionData, sessionData => {
  const ordersScope = getPermissionScope(
    sessionData?.permissionsWithScope,
    Permissions.ACCESS_ORDERS,
  )
  const isGoByPermission =
    ordersScope === true || ordersScope === 'brand' || ordersScope === 'all'
  const isDealerByPermission = ordersScope === 'organization'
  const isMppByPermission = ordersScope === 'office'

  if (isGoByPermission) {
    return 'go'
  }
  if (isDealerByPermission) {
    return 'd'
  }
  if (isMppByPermission) {
    return 'm'
  }
  return ''
})